import { render, staticRenderFns } from "./RoleViewGlobal.vue?vue&type=template&id=4ec6fc38"
import script from "./RoleViewGlobal.vue?vue&type=script&lang=js"
export * from "./RoleViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports